import React from "react";
import styled, { keyframes } from "styled-components";

// const fadeIn = keyframes`
//   from { opacity: 0; transform: translateY(20px); }
//   to { opacity: 1; transform: translateY(0); }
// `;

const float = keyframes`
  0% { transform: translateY(0px); }
  50% { transform: translateY(-10px); }
  100% { transform: translateY(0px); }
`;

const DashboardWrapper = styled.div`
  position: relative;
  min-height: 100vh;
  background-color: #f8fafc;
  overflow: hidden;
`;

const ElegantBackgroundCard = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  overflow: hidden;

  .gradient-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(135deg, rgba(248, 250, 252, 0.9) 0%, rgba(240, 242, 245, 0.9) 100%);
    backdrop-filter: blur(2px);
  }

  .grid-pattern {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: 
      linear-gradient(rgba(200, 200, 200, 0.1) 1px, transparent 1px),
      linear-gradient(90deg, rgba(200, 200, 200, 0.1) 1px, transparent 1px);
    background-size: 40px 40px;
    opacity: 0.5;
  }

  .corner-decor {
    position: absolute;
    width: 300px;
    height: 300px;
    border-radius: 50%;
    filter: blur(80px);
    opacity: 0.15;
  }

  .corner-1 {
    top: -100px;
    left: -100px;
    background: radial-gradient(circle, #4285F4 0%, transparent 70%);
  }

  .corner-2 {
    top: -100px;
    right: -100px;
    background: radial-gradient(circle, #EA4335 0%, transparent 70%);
  }

  .corner-3 {
    bottom: -100px;
    left: -100px;
    background: radial-gradient(circle, #34A853 0%, transparent 70%);
  }

  .corner-4 {
    bottom: -100px;
    right: -100px;
    background: radial-gradient(circle, #FBBC05 0%, transparent 70%);
  }
`;

const BackgroundCircle = styled.div`
  position: absolute;
  width: ${props => props.$size};
  height: ${props => props.$size};
  border-radius: 50%;
  background: ${props => props.$color};
  filter: blur(60px);
  animation: ${float} 6s ease-in-out infinite;
  animation-delay: ${props => props.$delay};
  top: ${props => props.$top};
  bottom: ${props => props.$bottom};
  left: ${props => props.$left};
  right: ${props => props.$right};
  z-index: 1;
`;

const ContentContainer = styled.div`
  position: relative;
  z-index: 2;
  padding: 2rem;
  max-width: 1800px;
  margin: 0 auto;
  width: 100%;
`;

const DashboardLayout = ({ children }) => {
  return (
    <DashboardWrapper>
      {/* Elementos decorativos de fundo */}
      <BackgroundCircle $size="200px" $top="10%" $left="5%" $color="rgba(66, 133, 244, 0.1)" $delay="0s" />
      <BackgroundCircle $size="300px" $top="30%" $right="8%" $color="rgba(234, 67, 53, 0.1)" $delay="0.5s" />
      <BackgroundCircle $size="150px" $bottom="15%" $left="10%" $color="rgba(251, 188, 5, 0.1)" $delay="1s" />
      
      {/* Card de fundo elegante */}
      <ElegantBackgroundCard>
        <div className="gradient-overlay" />
        <div className="grid-pattern" />
        <div className="corner-decor corner-1" />
        <div className="corner-decor corner-2" />
        <div className="corner-decor corner-3" />
        <div className="corner-decor corner-4" />
      </ElegantBackgroundCard>
      
      <ContentContainer>
        {children}
      </ContentContainer>
    </DashboardWrapper>
  );
};

export default DashboardLayout;